import appStore from '@/store';

export const dispatchSwitchCompany = (companyId: string, redirect?: string) => {
  return appStore.dispatch('switchCompany', redirect ? { companyId, redirect } : companyId);
};

export const dispatchLoadCompanyByHostname = () => {
  return appStore.dispatch('loadCompanyByHostname');
};

export const dispatchLoadCompanyUsers = () => {
  return appStore.dispatch('loadCompanyUsers');
};
